import { createFileRoute, Link } from "@tanstack/react-router";
import { loadPodcastList } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/podcast/")({
  loader: () => loadPodcastList(),
  head: () => ({
    meta: seo({
      title: "All Aboard Podcast",
      description: "All Aboard hosts IT and Security leaders. Straight talk for tackling the toughest problems facing cloud-forward companies.",
      url: "/podcast",
    }),
    links: seoLinks({ url: "/podcast" }),
  }),
  component: PodcastIndex,
});

function PodcastIndex() {
  const episodes = Route.useLoaderData();
  return (
    <div className="mx-auto max-w-screen-xl px-4 py-16 md:px-8">
      <h1 className="mb-2 font-display text-4xl font-bold text-charcoal">All Aboard Podcast</h1>
      <p className="mb-12 font-body text-lg text-gray-60">Straight talk for tackling the toughest problems facing cloud-forward companies.</p>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {episodes.map((ep) => (
          <Link key={ep.slug} to="/podcast/$slug" params={{ slug: ep.slug }} className="group overflow-hidden rounded-lg border border-[#DCDADA] transition-shadow hover:shadow-card">
            {ep.featured_image && (
              <div className="aspect-video overflow-hidden bg-gray-6">
                <img src={ep.featured_image} alt={ep.title} className="h-full w-full object-cover" loading="lazy" />
              </div>
            )}
            <div className="p-5">
              <div className="mb-2 text-xs text-gray-60"><time>{new Date(ep.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</time></div>
              <h2 className="mb-2 font-body text-lg font-bold text-charcoal group-hover:text-teal-dark">{ep.title}</h2>
              <p className="line-clamp-2 text-sm text-gray-60">{ep.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
